import * as React from 'react';
import { downloadData, downloadDataUri } from 'common/services/downloadData';

export function DownloadDataLink({ data, filename, className, onClick: _onClick, hidden, children } : {
    data : () => Blob,
    filename? : string,
    className? : string,
    onClick? : React.MouseEventHandler<HTMLAnchorElement>,
    hidden? : boolean,
    children? : React.ReactNode
}) {
    const onClick = (e : React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        downloadData(data(), filename);
        _onClick && _onClick(e);
    };

    return (
        <a
            href=""
            className={className}
            hidden={hidden}
            onClick={onClick}
        >
            {children}
        </a>
    );
}

const DATA = /^data:/i;

// TH 05/16/2017 -- A link for downloading a file, via an http/https URI or data URI.
// Provides IE 10+ and Edge support for downloading files, including via data URIs.
// NOTE: This is a purely functional React component. Calling code can call it like a normal
// React component:
//
//   <DownloadLink href={...}></DownloadLink>
export function DownloadLink({ href, download, className, onClick: _onClick, hidden, children } : {
    href : string,
    download? : string,
    className? : string,
    onClick? : React.MouseEventHandler<HTMLAnchorElement>,
    hidden? : boolean,
    children? : React.ReactNode
}) {
    const onClick = (e : React.MouseEvent<HTMLAnchorElement>) => {
        _onClick && _onClick(e);
    };

    return (
        <a
            href={href}
            className={className}
            download={download || 'attachment'}
            // TH 05/16/2017 -- target="_blank" is for the benefit of browsers that ignore the
            // download attribute, like IE and Edge.
            target="_blank"
            hidden={hidden}
            onClick={onClick}
        >
            {children}
        </a>
    );
}



// WEBPACK FOOTER //
// ./apps/portcall/downloadlink/view.tsx